import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Helmet } from "react-helmet";
import { Button, Col, Container, Row, Accordion, AccordionRow, BodyText, HeadingText } from '@paypalcorp/pp-react';
import { parseMessages } from '../../utilityHelper';
import * as FPT from '../../utility/fpt';
import { get } from 'lodash';
import { getCdnHostName } from '@paypalcorp/instance-location';
import withTheme from '../../common/withTheme';

const propertyInfo = parseMessages('directmodel/home');
const partnerListUrl = window.location.href.split('#')[1];
class Home extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        FPT.trackPage('main:givingfund:home');
        const countryCode = document.getElementsByTagName('body')[0].getAttribute('country');
        return (
            <div id="directModelWrapper" className="row">
                {/* Page non-searchable for IN */}
                <Helmet>
                    {countryCode === 'IN' && <meta name="robots" content="noindex" />}
                </Helmet>
                <Container>
                    <Row style={{ textAlign: 'center' }}>
                        <Col><HeadingText level={1}>{get(propertyInfo, 'directmodel.home.header')}</HeadingText></Col>
                    </Row>
                    <Row>
                        <Col><HeadingText level={2}>{get(propertyInfo, 'directmodel.home.subheader')}</HeadingText></Col>
                    </Row>
                    <Row>
                        <Col xxl={3}>
                            <Row>
                                <Col>
                                    <img src={`https://${getCdnHostName()}/paypal-ui/pictograms/multicolored/svg/giving-fund.svg`} alt='' width='120' />
                                </Col>
                                <Col className='justifyCenter'>
                                    <img src={`https://${getCdnHostName()}/webstatic/ppgf/directmodel/arrow.svg`} alt='' />
                                </Col>
                            </Row>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.step1title')}</BodyText>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.step1desc')}</BodyText>
                        </Col>
                        <Col xxl={3}>
                            <Row>
                                <Col>
                                    <img src={`https://${getCdnHostName()}/paypal-ui/pictograms/multicolored/svg/partner-integration.svg`} alt='' width='120' />
                                </Col>
                                <Col className='justifyCenter'>
                                    <img src={`https://${getCdnHostName()}/webstatic/ppgf/directmodel/arrow.svg`} alt='' />
                                </Col>
                            </Row>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.step2title')}</BodyText>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.step2desc')}</BodyText>
                        </Col>
                        <Col xxl={3}>
                            <Row>
                                <Col>
                                    <img src={`https://${getCdnHostName()}/paypal-ui/pictograms/multicolored/svg/lend-hands.svg`} alt='' width='120' />
                                </Col>
                                <Col className='justifyCenter'>
                                    <img src={`https://${getCdnHostName()}/webstatic/ppgf/directmodel/arrow.svg`} alt='' />
                                </Col>
                            </Row>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.step3title')}</BodyText>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.step3desc')}</BodyText>
                        </Col>
                        <Col xxl={3}>
                            <Row>
                                <Col>
                                    <img src={`https://${getCdnHostName()}/paypal-ui/pictograms/multicolored/svg/receive-payment.svg`} width='120' alt='' />
                                </Col>
                            </Row>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.step4title')}</BodyText>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.step4desc')}</BodyText>
                        </Col>
                    </Row>
                    <Row style={{ textAlign: 'center' }}>
                        <Col>
                            <Button data-fpti="enrollbtn" as="a" href="/givingfund/enroll" className="enrollbtn">{get(propertyInfo, 'directmodel.home.enrollnow')}</Button>
                        </Col>
                    </Row>
                    <Row style={{ textAlign: 'center' }}>
                        <Col>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.enrolldesc')}</BodyText>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <HeadingText level={2}>{get(propertyInfo, 'directmodel.home.faqs')}</HeadingText>
                        </Col>
                    </Row>
                    <Accordion name="faqs">
                        <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq1')}>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.faq1ans')}</BodyText>
                        </AccordionRow>
                        <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq2')}>
                            <BodyText as="p">{ReactHtmlParser(get(propertyInfo, 'directmodel.home.faq2ans'))}</BodyText>
                        </AccordionRow>
                        <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq3')}>
                            <BodyText as="p">{ReactHtmlParser(get(propertyInfo, 'directmodel.home.faq3ans'))}</BodyText>
                        </AccordionRow>
                        <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq4')}>
                            <BodyText as="p">{ReactHtmlParser(get(propertyInfo, 'directmodel.home.faq4ans'))}</BodyText>
                        </AccordionRow>
                        {partnerListUrl == 'faqs-row5' ? <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq5')} isOpen>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.faq5ans')}</BodyText>
                        </AccordionRow> : <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq5')}>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.faq5ans')}</BodyText>
                        </AccordionRow>}
                        <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq6')}>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.faq6ans')}</BodyText>
                        </AccordionRow>
                        <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq7')}>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.faq7ans')}</BodyText>
                        </AccordionRow>
                        <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq8')}>
                            <BodyText as="p">{ReactHtmlParser(get(propertyInfo, 'directmodel.home.faq8ans'))}</BodyText>
                        </AccordionRow>
                        <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq9')}>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.faq9ans')}</BodyText>
                        </AccordionRow>
                        <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq10')}>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.faq10ans')}</BodyText>
                        </AccordionRow>
                        <AccordionRow headerClassName="accordionHead" heading={get(propertyInfo, 'directmodel.home.faq11')}>
                            <BodyText as="p">{get(propertyInfo, 'directmodel.home.faq11ans')}</BodyText>
                        </AccordionRow>
                    </Accordion>
                </Container>
            </div>
        );

    }
}
export default withTheme(Home);